
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","viewBox":"0 0 19 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.861 15.5706H4.57163C4.25593 15.5706 4 15.3248 4 15.0216C4 14.7185 4.25593 14.4727 4.57163 14.4727H14.861C15.1767 14.4727 15.4327 14.7185 15.4327 15.0216C15.4327 15.3248 15.1767 15.5706 14.861 15.5706Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.838 12.4727H6.5017C6.17284 12.4727 5.90625 12.2269 5.90625 11.9237C5.90625 11.6206 6.17284 11.3748 6.5017 11.3748H14.838C15.1669 11.3748 15.4335 11.6206 15.4335 11.9237C15.4335 12.2269 15.1669 12.4727 14.838 12.4727Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.9571 9.37476H6.38261C6.11952 9.37476 5.90625 9.12899 5.90625 8.82583C5.90625 8.52266 6.11952 8.2769 6.38261 8.2769H14.9571C15.2202 8.2769 15.4335 8.52266 15.4335 8.82583C15.4335 9.12899 15.2202 9.37476 14.9571 9.37476Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.861 6.2771H4.57163C4.25593 6.2771 4 6.03134 4 5.72817C4 5.425 4.25593 5.17924 4.57163 5.17924H14.861C15.1767 5.17924 15.4327 5.425 15.4327 5.72817C15.4327 6.03134 15.1767 6.2771 14.861 6.2771Z","fill":"#E0320B"}})])
          )
        }
      }
    